<template>
  <div class="relative inline-block my-1 text-left">
    <div>
      <button
        id="options-menu"
        type="button"
        class="group relative inline-flex items-center w-full"
        :class="collapsed ? 'px-3 py-2' : 'p-3'"
        :aria-label="collapsed && label ? label : undefined"
        aria-haspopup="true"
        aria-expanded="true"
        @click="handcleClickMenuButton"
      >
        <slot name="title" />
        <bs-icon v-if="!collapsed" name="chevron_down" class="absolute bottom-0 right-3 top-0 m-auto" width="12" />
      </button>
    </div>

    <div
      :class="{ hidden: !isOpen }"
      class="flex flex-col w-full"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    // NOTE: サイドバーが折りたたまれているとき、アイコンのみの表示に切り替える
    collapsed: {
      type: Boolean,
      default: false,
    },
    // NOTE: アイコンのみの表示になるとボタンの読み上げ名が失われるため、代わりに aria-label へ設定する
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    handcleClickMenuButton() {
      this.isOpen = !this.isOpen;
    },
  },
});
</script>
